import { icons } from "lucide-react";
import React from "react";

interface UiIconProps {
  children: React.ReactNode;
  color?: string;
  size?: number;
}
const UiIcon = ({ children, color, size }: UiIconProps) => {
  return <span style={{ color, fontSize: size }}>{children}</span>;
};

export default UiIcon;
